var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 180 160",
      "fill": "none",
      "aria-hidden": "true"
    }
  }, [_c('ellipse', {
    attrs: {
      "cx": "90",
      "cy": "85",
      "rx": "80",
      "ry": "69",
      "fill": "#EEF0FF"
    }
  }), _c('rect', {
    attrs: {
      "x": "24",
      "y": "84",
      "width": "64",
      "height": "51",
      "rx": "6",
      "fill": "#E6C79A"
    }
  }), _c('path', {
    attrs: {
      "d": "M24 92h64M50 84v22h13V84",
      "stroke": "#C49A64",
      "stroke-width": "3"
    }
  }), _c('rect', {
    attrs: {
      "x": "47",
      "y": "44",
      "width": "54",
      "height": "40",
      "rx": "5",
      "fill": "#F4DAB3"
    }
  }), _c('path', {
    attrs: {
      "d": "M68 44v17h12V44",
      "fill": "#D9B482"
    }
  }), _c('rect', {
    attrs: {
      "x": "92",
      "y": "64",
      "width": "65",
      "height": "71",
      "rx": "8",
      "fill": "white",
      "stroke": "#8B80D5",
      "stroke-width": "3"
    }
  }), _c('path', {
    attrs: {
      "d": "M93 86h63",
      "stroke": "#8B80D5",
      "stroke-width": "3"
    }
  }), _c('path', {
    attrs: {
      "d": "M108 57v15m33-15v15",
      "stroke": "#4F35BC",
      "stroke-width": "5",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "m109 108 10 10 21-21",
      "stroke": "#4F35BC",
      "stroke-width": "5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "m28 44 3 7 7 3-7 3-3 7-3-7-7-3 7-3Z",
      "fill": "#AAA1E5"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }